export const setLocalStorageItem = (key, value) => localStorage.setItem(key, value);
export const getLocalStorageItem = key => localStorage.getItem(key);
export const setSessionItem = (key, value) => sessionStorage.setItem(key, value);
export const getSessionItem = key => sessionStorage.getItem(key);
